import { render } from "./ContentType.vue?vue&type=template&id=ecb98530&scoped=true"
import script from "./ContentType.vue?vue&type=script&lang=js"
export * from "./ContentType.vue?vue&type=script&lang=js"

import "./ContentType.vue?vue&type=style&index=0&id=ecb98530&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb98530"]])

export default __exports__